import React from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { VentLogo } from './VentLogo';

interface BiometricGateProps {
  onAuthenticate: () => Promise<boolean>;
}

const BiometricGate: React.FC<BiometricGateProps> = ({ onAuthenticate }) => {
  const [authenticating, setAuthenticating] = React.useState(false);

  const handleUnlock = async () => {
    setAuthenticating(true);
    await onAuthenticate();
    setAuthenticating(false);
  };

  // Auto-attempt on mount
  React.useEffect(() => {
    handleUnlock();
  }, []);

  return (
    <div className="fixed inset-0 z-[100] bg-background flex flex-col items-center justify-center gap-8 pt-[env(safe-area-inset-top,0px)]">
      <VentLogo />
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <Shield className="h-12 w-12 text-primary" />
        <h2 className="text-xl font-semibold text-foreground">App Locked</h2>
        <p className="text-muted-foreground text-sm max-w-xs">
          Use Face ID or Touch ID to unlock and access your private content.
        </p>
        <Button
          onClick={handleUnlock}
          disabled={authenticating}
          size="lg"
          className="mt-4"
        >
          {authenticating ? 'Authenticating...' : 'Unlock with Biometrics'}
        </Button>
      </div>
    </div>
  );
};

export default BiometricGate;
